export default "__VITE_ASSET__BihHHq3F__"